import { type FC } from 'react';

import { SERIA_PLUS_IMAGE_HEIGHT, SERIA_PLUS_IMAGE_WIDTH } from '../../constants';
import { type SeriaPlusTabScheme } from '../../settings/seriaPlusTypes';

import styles from './SeriaPlusSlide.css';

type SeriaPlusSlideProps = {
  slide: SeriaPlusTabScheme['slides'][number];
  isActive: boolean;
  /**
   * Загружать и декодировать изображение немедленно (без ленивой загрузки).
   * Используется для LCP-картинки, когда секция является целью перехода по якорю.
   */
  isEager?: boolean;
};

export const SeriaPlusSlide: FC<SeriaPlusSlideProps> = props => {
  const { slide, isActive, isEager = false } = props;

  return (
    <article className={styles['slide']} data-testid="seria-plus-carousel-slide">
      <div className={styles['slide-inner']} data-testid={isActive ? 'seria-plus-carousel-active-slide' : undefined}>
        <img
          alt={slide.imageAlt}
          className={styles['slide-image']}
          data-testid="seria-plus-carousel-slide-image"
          decoding={isEager ? 'sync' : 'async'}
          height={SERIA_PLUS_IMAGE_HEIGHT}
          loading={isEager ? 'eager' : 'lazy'}
          src={slide.imageSrc}
          width={SERIA_PLUS_IMAGE_WIDTH}
        />
      </div>
    </article>
  );
};
